// extracted by mini-css-extract-plugin
export default {"content-page":"layout_content-page__MxAKh"};